// handle product images
function _handleSecondaryProductImages(show_secondary_images = false) {

    let is_mobile = window.matchMedia("(max-width: 769px)").matches;

    if (show_secondary_images) {
        $('.template-product').addClass('secondary-images');
    } else {
        $('.template-product').removeClass('secondary-images');
    }

    if (is_mobile) {
        $('.product__main-photos-slider-parent').slick('refresh');
    }
}

// handle dynamic phyla plus upsell checkbox + popup content
function _updatePhylaPlusUpsell(selection, product_id) {
    if (product_id === "6779878441159") {
        // if 3-step
        if (selection == 'recurring') {
            $('.product__phyla-plus-checkbox').find('.subtext').text('Phyla+ +$30 every 60 days');
            // $('.product__phyla-plus-checkbox').find('.content p').html('Clear your acne faster with consistent use. Free Shipping every 2 months. CANCEL ANYTIME.');
            $('#phylaPlusUpsellOverlay').find('.popup-price').text('+$30 (renews every 60 days)');
            $('#phylaPlusUpsellOverlay').find('.popup-disclaimer').html('');
        } else {
            $('.product__phyla-plus-checkbox').find('.subtext').text('Phyla+ +$9 every 60 days')
            // $('.product__phyla-plus-checkbox').find('.content p').html('Clear your acne faster with consistent use. Free Shipping every 2 months. CANCEL ANYTIME.');
            $('#phylaPlusUpsellOverlay').find('.popup-price').text('+$9 (renews every 60 days)');
            $('#phylaPlusUpsellOverlay').find('.popup-disclaimer').html('');
        }
    } else if (product_id === "6783789269191") {
        // if serum
        if (selection == 'recurring') {
            $('.product__phyla-plus-checkbox').find('.subtext').text('Phyla+ +$30 every 60 days');
            // $('.product__phyla-plus-checkbox').find('.content p').html('Clear your acne faster with consistent use. Free Shipping every 2 months. CANCEL ANYTIME.');
            $('#phylaPlusUpsellOverlay').find('.popup-price').text('+$30 (renews every 60 days)');
            $('#phylaPlusUpsellOverlay').find('.popup-disclaimer').html('');
        } else {
            $('.product__phyla-plus-checkbox').find('.subtext').text('Phyla+ +$19 every 60 days')
            // $('.product__phyla-plus-checkbox').find('.content p').html('Clear your acne faster with consistent use. Free Shipping every 2 months. CANCEL ANYTIME.');
            $('#phylaPlusUpsellOverlay').find('.popup-price').text('+$19 (renews every 60 days)');
            $('#phylaPlusUpsellOverlay').find('.popup-disclaimer').html('');
        }
    }
}

// declare/handle custom subscription/product option ui select listeners
function setUpCustomSubscriptionSelectListeners(product_id) {
    let $productForm = $('.product-single__form');

    let form_hides_primary = $productForm.hasClass('hide-primary');

    let $customSubscriptionSelectDisplay = $('.product__custom-subscription-select').find('.display');
    let $customSubscriptionSelectControls = $('.product__custom-subscription-select').find('.select');

    let $displayToggle = $customSubscriptionSelectDisplay.find('.control');

    $displayToggle.on('click', function(event) {
        $(event.target).closest('.product__custom-subscription-select').addClass('expanded');
    });

    let $customThreeStepPhylaPlusCheckbox = $('.product__phyla-plus-checkbox').find('.custom-checkbox-upsell');

    $customThreeStepPhylaPlusCheckbox.on('click', 'input', function(event) {
        let is_checked = $(event.target).is(':checked')

        if (is_checked) {
            _handleSecondaryProductImages(is_checked);

            if (form_hides_primary) {
                $('.template-product').find('.display-add-to-cart').addClass('hide');
            } else {
                $('.template-product').find('.primary-add-to-cart').addClass('hide');
            }

            $('.template-product').find('.secondary-add-to-cart').removeClass('hide');
        } else {
            _handleSecondaryProductImages()

            $('.template-product').find('.secondary-add-to-cart').addClass('hide');

            if (form_hides_primary) {
                $('.template-product').find('.display-add-to-cart').removeClass('hide');
            } else {
                $('.template-product').find('.primary-add-to-cart').removeClass('hide')
            }
        }
    })

    // PDP custom subscription/product option UI select input listeners
    $customSubscriptionSelectControls.on('click', 'input', function(event) {
        console.log('heyo!');
        let value = $(event.target).val();

        let $select_parent = $(event.target).closest('.select');
        let $label_parent = $(event.target).closest('label');

        let $parent = $(event.target).closest('.product__custom-subscription-select');

        let $customThreeStepPhylaPlusCheckbox = $('.product__phyla-plus-checkbox').find('.custom-checkbox-upsell');
        let phyla_plus_checked = false;

        // $select_parent.find('label.custom-subscription-option').removeClass('active');
        // $label_parent.addClass('active');

        $parent.find('div.custom-subscription-option').removeClass('active');
        $parent.find(`div.custom-subscription-option[data-option-type='${value}']`).addClass('active');

        console.log('value?', value);

        if (value === 'recurring') {
            _updatePhylaPlusUpsell(value, product_id);

            if ($customThreeStepPhylaPlusCheckbox.length) {
                $customThreeStepPhylaPlusCheckbox.removeClass('hide');

                phyla_plus_checked = $customThreeStepPhylaPlusCheckbox.find('input').is(':checked');
            }

            if (phyla_plus_checked) {
                // _handleSecondaryProductImages(phyla_plus_checked);

                if (form_hides_primary) {
                    $('.template-product').find('.display-add-to-cart').addClass('hide');
                } else {
                    $('.template-product').find('.primary-add-to-cart').addClass('hide');
                }

                $('.template-product').find('.secondary-add-to-cart').removeClass('hide');
            } else {
                // _handleSecondaryProductImages()

                $('.template-product').find('.secondary-add-to-cart').addClass('hide');

                if (form_hides_primary) {
                    $('.template-product').find('.display-add-to-cart').removeClass('hide');
                } else {
                    $('.template-product').find('.primary-add-to-cart').removeClass('hide');
                }
            }

            $('.template-product').find('input[data-name="Subscribe and Save"]').trigger('click');
        } else if (value === 'recurring-plus') {
            $('.template-product').find('.primary-add-to-cart').addClass('hide');
            $('.template-product').find('.secondary-add-to-cart').removeClass('hide');
            $('.template-product').find('input[data-name="Subscribe and Save"]').trigger('click');
        } else {

            if ($customThreeStepPhylaPlusCheckbox.length) {
                // $customThreeStepPhylaPlusCheckbox.addClass('hide');
                _updatePhylaPlusUpsell(value, product_id);
                _handleSecondaryProductImages();
            }

            if (phyla_plus_checked) {
                _handleSecondaryProductImages(phyla_plus_checked);

                if (form_hides_primary) {
                    $('.template-product').find('.display-add-to-cart').addClass('hide');
                } else {
                    $('.template-product').find('.primary-add-to-cart').addClass('hide');
                }

                $('.template-product').find('.secondary-add-to-cart').removeClass('hide');
            } else {
                _handleSecondaryProductImages()

                $('.template-product').find('.secondary-add-to-cart').addClass('hide');

                if (form_hides_primary) {
                    $('.template-product').find('.display-add-to-cart').removeClass('hide');
                } else {
                    $('.template-product').find('.primary-add-to-cart').removeClass('hide');
                }
            }

            $('.template-product').find('input.loop-one-time-purchase-option-radio').trigger('click');
        }

        $(event.target).closest('.product__custom-subscription-select').removeClass('expanded');
    });

    // 3-step pdp custom Phyla+ upsell checkbox ui listeners

    // Phyla+ bundle add to cart listener
    $productForm.on('click', '.secondary-add-to-cart', function(event) {
        let $button = $(event.target).closest('.secondary-add-to-cart');
        let variant_id = $button.data('plus-variant-id');
        let selling_plan_id = $button.data('plus-selling-plan-id');

        let data = {
            "id": variant_id,
            "quantity": 1,
            "selling_plan": selling_plan_id
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
                window.SLIDECART_UPDATE(() => console.log('Cart updated!'))
                window.SLIDECART_OPEN();
            }
        });
    })

    // 3-step-kit Phyla+ Pop-up listeners/upsell trigger
    if (form_hides_primary) {
        $productForm.on('click', '.display-add-to-cart', function(event) {
            $('body').addClass('popup-open');
            $('#phylaPlusUpsellOverlay').addClass('active');
        })

        $('#phylaPlusUpsellOverlay').on('click', '.phyla-plus-upsell-confirm', function(event) {
            $('body').removeClass('popup-open');
            $('#phylaPlusUpsellOverlay').removeClass('active');
            $('.template-product').find('.secondary-add-to-cart').trigger('click');
        })

        $('#phylaPlusUpsellOverlay').on('click', '.phyla-plus-upsell-continue', function(event) {
            event.preventDefault();
            $('body').removeClass('popup-open');
            $('#phylaPlusUpsellOverlay').removeClass('active');
            $('.template-product').find('.primary-add-to-cart').trigger('click');
        })

        // exit pop-up
        $('#phylaPlusUpsellOverlay').on('click', '.overlay-container', function(event) {
            event.preventDefault();
            // console.log('popup background/overlay click!');

            let $popup_content = $(event.target).closest('.popup-content');

            if ($popup_content.length) {
                return false;
            }

            $('body').removeClass('popup-open');
            $('#phylaPlusUpsellOverlay').removeClass('active');
        })
    }
};

// BEGIN LOOP CUSTOM WIDGET

// render custom subscription ui select - loop
function renderCustomSubscriptionSelect(product_id) {

    let loop_product = window.loopProps[product_id];
    console.log('product_id?', product_id, typeof(product_id));
    console.log('loop product?', loop_product);

    let unit_price = loop_product.product.price / 100;

    let discounted_price = unit_price;

    loop_product.product.selling_plan_groups.map((plan) => {
        if (plan.name === 'Subscribe and Save') {
            discounted_price = plan.selling_plans[0].price_adjustments[0].value / 100;
        }
    });

    let discount_diff = unit_price - discounted_price;
    let discount_percentage = (discount_diff * 100) / unit_price;

    let custom_subscription_select_to_render = false;
    let three_step_phyla_plus_checkbox_to_render = false;

    if (product_id === "6779878441159") {
    // if 3-step kit, render with phyla plus option

    custom_subscription_select_to_render =`
    <div class="custom-subscription-select-inner">

        <div class="display">
            <div class="custom-subscription-option active" data-option-type="recurring">
                <div class="content">
                    <div class="custom-subscription-option-price">
                        <p style="font-weight: 700;">Subscribe and Save ${Math.trunc(discount_percentage)}%</p> <p style="margin-left: 10px;"><span style="text-decoration: line-through; opacity: 0.5; margin-right: 10px;">$${Math.trunc(unit_price)}</span>$${Math.trunc(discounted_price)} / 2 MONTHS</p>
                    </div>
                </div>
                <div class="control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.342" height="6.171" viewBox="0 0 11.342 6.171">
                    <path id="Path_11483" data-name="Path 11483" d="M21278.945,605l4.965,4.964,4.963-4.964" transform="translate(-21278.238 -604.293)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </svg>
                </div>
            </div>
            <div class="custom-subscription-option" data-option-type="one-time">
                <div class="content">
                    <div>
                    <p>One-Time Purchase</p><p style="margin-left: 10px;"><b>$${Math.trunc(unit_price)}</b></p>
                    </div>
                </div>
                <div class="control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.342" height="6.171" viewBox="0 0 11.342 6.171">
                    <path id="Path_11483" data-name="Path 11483" d="M21278.945,605l4.965,4.964,4.963-4.964" transform="translate(-21278.238 -604.293)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="select">
            <label class="custom-subscription-option" for="custom-subscription-select-recurring">
            <div class="content">
                <div class="custom-subscription-option-price">
                    <p style="font-weight: 700;">Subscribe and Save ${Math.trunc(discount_percentage)}%</p> <p style="margin-left: 10px;"><span style="text-decoration: line-through; opacity: 0.5; margin-right: 10px;">$${Math.trunc(unit_price)}</span>$${Math.trunc(discounted_price)} / 2 MONTHS</p>
                </div>
            </div>
            <div class="control">
                <input class="opacity-0 width-0 height-0 absolute filter" type="radio" id="custom-subscription-select-recurring" name="custom-product-select-type" checked="true" value="recurring">
                <span class="checkmark"></span>
            </div>
            </label>
            <label class="custom-subscription-option" for="custom-subscription-select-one-time">
            <div class="content">
                <div>
                <p>One-Time Purchase</p><p style="margin-left: 10px;"><b>$${Math.trunc(unit_price)}</b></p>
                </div>
            </div>
            <div class="control">
                <input class="opacity-0 width-0 height-0 absolute filter" type="radio" id="custom-subscription-select-one-time" name="custom-product-select-type" value="one-time">
                <span class="checkmark"></span>
            </div>
            </label>
        </div>

    </div>
    `;

    three_step_phyla_plus_checkbox_to_render = `
    <label class="custom-checkbox-upsell" for="custom-subscription-checkbox-recurring-plus">
    <div class="control">
        <input class="opacity-0 width-0 height-0 absolute filter" type="checkbox" id="custom-subscription-checkbox-recurring-plus" name="custom-phyla-plus-checkbox" value="recurring-plus">
        <span class="checkmark"></span>
    </div>
    <div class="content">
        <div>
            <span class="subtext" style="font-size: 18px;">Phyla+ +$30 every 60 days</span>
        </div>
        <div>
            <p>24/7 personalized access to skincare experts to guide you on your journey to clear skin.<br>See below for more details.</p>
        </div>
    </div>
    </label>
    `;

    } else if (product_id === "6783789269191") {
    // if serum, render with phyla plus option

    custom_subscription_select_to_render =`
    <div class="custom-subscription-select-inner">

        <div class="display">
            <div class="custom-subscription-option active" data-option-type="recurring">
                <div class="content">
                    <div class="custom-subscription-option-price">
                        <p style="font-weight: 700;">Subscribe and Save ${Math.trunc(discount_percentage)}%</p> <p style="margin-left: 10px;"><span style="text-decoration: line-through; opacity: 0.5; margin-right: 10px;">$${Math.trunc(unit_price)}</span>$${Math.trunc(discounted_price)} / 2 MONTHS</p>
                    </div>
                </div>
                <div class="control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.342" height="6.171" viewBox="0 0 11.342 6.171">
                    <path id="Path_11483" data-name="Path 11483" d="M21278.945,605l4.965,4.964,4.963-4.964" transform="translate(-21278.238 -604.293)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </svg>
                </div>
            </div>
            <div class="custom-subscription-option" data-option-type="one-time">
                <div class="content">
                    <div>
                    <p>One-Time Purchase</p><p style="margin-left: 10px;"><b>$${Math.trunc(unit_price)}</b></p>
                    </div>
                </div>
                <div class="control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.342" height="6.171" viewBox="0 0 11.342 6.171">
                    <path id="Path_11483" data-name="Path 11483" d="M21278.945,605l4.965,4.964,4.963-4.964" transform="translate(-21278.238 -604.293)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="select">
            <label class="custom-subscription-option" for="custom-subscription-select-recurring">
            <div class="content">
                <div class="custom-subscription-option-price">
                    <p style="font-weight: 700;">Subscribe and Save ${Math.trunc(discount_percentage)}%</p> <p style="margin-left: 10px;"><span style="text-decoration: line-through; opacity: 0.5; margin-right: 10px;">$${Math.trunc(unit_price)}</span>$${Math.trunc(discounted_price)} / 2 MONTHS</p>
                </div>
            </div>
            <div class="control">
                <input class="opacity-0 width-0 height-0 absolute filter" type="radio" id="custom-subscription-select-recurring" name="custom-product-select-type" checked="true" value="recurring">
                <span class="checkmark"></span>
            </div>
            </label>
            <label class="custom-subscription-option" for="custom-subscription-select-one-time">
            <div class="content">
                <div>
                <p>One-Time Purchase</p><p style="margin-left: 10px;"><b>$${Math.trunc(unit_price)}</b></p>
                </div>
            </div>
            <div class="control">
                <input class="opacity-0 width-0 height-0 absolute filter" type="radio" id="custom-subscription-select-one-time" name="custom-product-select-type" value="one-time">
                <span class="checkmark"></span>
            </div>
            </label>
        </div>

    </div>
    `;

    three_step_phyla_plus_checkbox_to_render = `
    <label class="custom-checkbox-upsell" for="custom-subscription-checkbox-recurring-plus">
    <div class="control">
        <input class="opacity-0 width-0 height-0 absolute filter" type="checkbox" id="custom-subscription-checkbox-recurring-plus" name="custom-phyla-plus-checkbox" value="recurring-plus">
        <span class="checkmark"></span>
    </div>
    <div class="content">
        <div>
            <span class="subtext" style="font-size: 18px;">Phyla+ +$30 every 60 days</span>
        </div>
        <div>
            <p>24/7 personalized access to skincare experts to guide you on your journey to clear skin.<br>See below for more details.</p>
        </div>
    </div>
    </label>
    `;
    
    } else {
    // render without phyla plus option

    custom_subscription_select_to_render =`
    <div class="custom-subscription-select-inner">

        <div class="display">
            <div class="custom-subscription-option active" data-option-type="recurring">
                <div class="content">
                    <div class="custom-subscription-option-price">
                        <p style="font-weight: 700;">Subscribe and Save ${Math.trunc(discount_percentage)}%</p> <p style="margin-left: 10px;"><span style="text-decoration: line-through; opacity: 0.5; margin-right: 10px;">$${Math.trunc(unit_price)}</span>$${Math.trunc(discounted_price)} / 2 MONTHS</p>
                    </div>
                </div>
                <div class="control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.342" height="6.171" viewBox="0 0 11.342 6.171">
                    <path id="Path_11483" data-name="Path 11483" d="M21278.945,605l4.965,4.964,4.963-4.964" transform="translate(-21278.238 -604.293)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </svg>
                </div>
            </div>
            <div class="custom-subscription-option" data-option-type="one-time">
                <div class="content">
                    <div>
                    <p>One-Time Purchase</p><p style="margin-left: 10px;"><b>$${Math.trunc(unit_price)}</b></p>
                    </div>
                </div>
                <div class="control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.342" height="6.171" viewBox="0 0 11.342 6.171">
                    <path id="Path_11483" data-name="Path 11483" d="M21278.945,605l4.965,4.964,4.963-4.964" transform="translate(-21278.238 -604.293)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="select">
            <label class="custom-subscription-option" for="custom-subscription-select-recurring">
            <div class="content">
                <div class="custom-subscription-option-price">
                    <p style="font-weight: 700;">Subscribe and Save ${Math.trunc(discount_percentage)}%</p> <p style="margin-left: 10px;"><span style="text-decoration: line-through; opacity: 0.5; margin-right: 10px;">$${Math.trunc(unit_price)}</span>$${Math.trunc(discounted_price)} / 2 MONTHS</p>
                </div>
            </div>
            <div class="control">
                <input class="opacity-0 width-0 height-0 absolute filter" type="radio" id="custom-subscription-select-recurring" name="custom-product-select-type" checked="true" value="recurring">
                <span class="checkmark"></span>
            </div>
            </label>
            <label class="custom-subscription-option" for="custom-subscription-select-one-time">
            <div class="content">
                <div>
                <p>One-Time Purchase</p><p style="margin-left: 10px;"><b>$${Math.trunc(unit_price)}</b></p>
                </div>
            </div>
            <div class="control">
                <input class="opacity-0 width-0 height-0 absolute filter" type="radio" id="custom-subscription-select-one-time" name="custom-product-select-type" value="one-time">
                <span class="checkmark"></span>
            </div>
            </label>
        </div>

    </div>
    `;

    }

    if (custom_subscription_select_to_render) {
        $('.product__custom-subscription-select').html(custom_subscription_select_to_render);
    }

    if (three_step_phyla_plus_checkbox_to_render) {
        $('.product__phyla-plus-checkbox').html(three_step_phyla_plus_checkbox_to_render);
    }

    setUpCustomSubscriptionSelectListeners(product_id);
}

// loop loaded poll
(function(){
    let product_id = $('body').find('.product-section').attr('data-product-id');

    let loopPoll = setInterval(function (){
        console.log('loop polling', window.loopProps[product_id]);
        if(window.loopProps[product_id]) {
            clearInterval(loopPoll);

            if ($('.template-product').find('.display-add-to-cart').length) {
                $('.template-product').find('.primary-add-to-cart').addClass('hide');
                $('.template-product').find('.display-add-to-cart').removeClass('hide');
            }

            renderCustomSubscriptionSelect(product_id);
        }
      }, 500);
})();

// END LOOP CUSTOM WIDGET

// slick sliders
(function(){
    $('.product__main-photos-slider-parent').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        responsive: [
              {
                      breakpoint: 901,
                      settings: 'unslick'
              }
        ]
    });
})();

// general listeners
(function() {
    $('.template-product').on('click', '.phyla-plus-learn-more', function(event) {
        event.preventDefault();
        $('body').addClass('popup-open');
        $('#phylaPlusOverlay').addClass('active');
    })

    $('.template-product').on('click', '.popup-exit', function(event) {
        $('body').removeClass('popup-open');
        $('#phylaPlusOverlay').removeClass('active');
    })

    $('.template-product').on('click', '.product-tab-nav-control', function(event) {
        $('.product-tab-nav-control').removeClass('active');
        $('.product-tabs-content-container').removeClass('active');

        let $target = $(event.target);
        $target.addClass('active');

        let tab_nav_value = $target.attr('data-tab');

        let $parent = $target.closest('.product-tabs-inner');
        $parent.find(`.product-tabs-content-container[data-content="${tab_nav_value}"]`).addClass('active');
    })

    $('#productTabs').on('change', function(event) {
        let $target = $(event.target);
        let tab_nav_value = $(this).find(":selected").val();
        let $parent = $target.closest('.product-tabs-inner');
        console.log('tab nav value', tab_nav_value);

        $('.product-tabs-content-container').removeClass('active');
        $parent.find(`.product-tabs-content-container[data-content="${tab_nav_value}"]`).addClass('active');
    })

    $('.description-collapsibles').on('change', 'input', function(event) {
        if ($(this).is(':checked')) {
          $('.description-collapsibles').find('input').prop("checked", false);
          $(this).prop("checked", true);
          $('html, body').animate({scrollTop: $(this).offset().top}, 1000)
        }
    })

    $('.faq-collapsibles').on('change', 'input', function(event) {
        if ($(this).is(':checked')) {
          $('.faq-collapsibles').find('input').prop("checked", false);
          $(this).prop("checked", true);
          $('html, body').animate({scrollTop: $(this).offset().top}, 1000)
        }
    })

    $('.product-ab-info-slide-wrap').on('scroll', function (event) {
        let $scrollPanel = $('.product-ab-info-slide-wrap');
        // console.log('slide scroll?');
        let scroll_position = $scrollPanel[0].scrollLeft;
        // console.log('scroll position?', scroll_position);
        let $scrollInput = $('.slide-control-wrap').find('input');

        let scroll_total = $scrollPanel[0].scrollWidth - $scrollPanel[0].offsetWidth;

        // console.log('scroll total?', scroll_total);
        let scroll_percentage = (scroll_position/scroll_total) * 100;

        $scrollInput.val(scroll_percentage);
    })

    $('.slide-control-wrap').on('change', 'input', function (event) {
        let scroll_value = $(this).val();
        let $scrollPanel = $('.product-ab-info-slide-wrap');

        let scroll_total = $scrollPanel[0].scrollWidth - $scrollPanel[0].offsetWidth;
        let scroll_percentage = scroll_total*(scroll_value/100);

        // console.log(scroll_total);
        // console.log(percentage);
        $scrollPanel.scrollLeft(scroll_percentage);
    })
})();